<template lang="pug">
  .programs-container
    .searchbar-container.column.top.center.m-bottom-2
      search-bar(@searchedPrograms='setSearchParams' @changePageSize='changeDefaultPageSize')
    .main-container
      .row.space-between
        h1.title-big.bolder.m-bottom-3 {{ $t('listPrograms.title') }}
        .row.space-around
          button.catalog.secondary-button.with-icon(v-if='false' @click='handleCatalogue')
            simple-svg.blue-icon.m-right-1(:filepath='catalogIcon' :width='"25px"' :height='"25px"')
            | {{ $t('listPrograms.catalog') }}
          a.suggest.secondary-button.with-icon(:href='suggestionForm' target='_blank' rel='noopener noreferrer')
            simple-svg.blue-icon.m-right-1(:filepath='fileTextIcon' :width='"20px"' :height='"20px"')
            | {{ $t('listPrograms.suggest') }}
      paginated-table(
        :pageSize='defaultPageSize'
        :totalCount='totalCount'
        :getPage='getMoreFilteredOwnedPrograms'
        ref='paginatedTable'
      )
        search-results(
          @clearFilters='clearFilters'
          :searchedPrograms='hasFilters'
          ref='searchResults'
          :totalCount='totalCount'
        )
        .program-card-grid(v-if='navigationOptions.list')
          program-card(v-for='program in isCustom ? getCustomProgramsListForCard : getProgramsListForCard' :program='program' :key='program.id')
        .program-card-list(v-if='navigationOptions.card')
          carousel-program-card(v-for='program in ownedFilteredPrograms' noMargin :program='program' :key='program.id')
      .carousel-container.m-bottom-4
        carousel(
          v-if='filteredPrograms.programs.length'
          :title='$t("listPrograms.otherPrograms")'
          :page='filteredPrograms.page'
          :totalPages='filteredPrograms.totalPages'
          @getNextPage='getMoreFilteredPrograms'
        )
          slide(v-for='filteredProgram in filteredPrograms.programs' :key='filteredProgram.id')
            carousel-program-card.card(:program='filteredProgram' :key='filteredProgram.id')
    view-catalogue-modal(v-if='showViewCatalogueModal')
    used-content-drawer
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import SearchBar from '@/components/EducationalPrograms/SearchBar'
import SearchResults from '@/components/EducationalPrograms/SearchResults'
import ProgramCard from '@/components/EducationalPrograms/ProgramCard'
import PaginatedTable from '@/components/PaginatedTable'
import CarouselProgramCard from '@/components/EducationalProgramCard'
import Carousel from '@/components/Carousel'
import ViewCatalogueModal from '@/components/Modals/ViewCatalogueModal'
import UsedContentDrawer from '../components/UsedContent/UsedContentDrawer'

import fileTextIcon from '@/assets/ic_file-text.svg'
import catalogIcon from '@/assets/ic_catalog.svg'

import { firstPage, defaultProgramsPageSize, educationalProgramStatus, educationalProgramLanguageStatus } from '../utils/constants'
import userRole from '../mixins/userRole'

export default {
  name: 'educationalPrograms',
  mixins: [userRole],
  components: {
    UsedContentDrawer,
    ProgramCard,
    CarouselProgramCard,
    Carousel,
    PaginatedTable,
    SearchBar,
    SearchResults,
    ViewCatalogueModal
  },
  data () {
    return {
      fileTextIcon,
      catalogIcon,
      suggestionForm: process.env.VUE_APP_SUGGEST_FORM,
      defaultPageSize: defaultProgramsPageSize,
      firstPage,
      filters: {
        name: this.$route.query.name || '',
        categoryId: parseInt(this.$route.query.categoryId) || null,
        language: this.$route.query.language || null
      }
    }
  },
  async created() {
    this.showElement({ element: 'fullPageLoader' })
    await this.hydrateProfile()
    await this.clearPrograms()
    await this.hydrateCategories()
    await this.hydrateAges()
    await this.getMoreFilteredOwnedPrograms()
    await this.getMoreFilteredPrograms({ pageNumber: 0 })
    await this.getMoreFilteredPrograms({ pageNumber: 1 })
    this.hideElement({ element: 'fullPageLoader' })
  },
  watch: {
    locale() {
      this.getMoreFilteredOwnedPrograms()
    }
  },
  destroyed() {
    this.setNavigationOptions({ option: 'list' })
  },
  computed: {
    ...mapState({
      defaultFilteredPrograms: state => state.educationalProgram.filteredPrograms,
      defaultOwnedFilteredPrograms: state => state.educationalProgram.filteredOwnedPrograms.programs,
      defaultTotalCount: state => state.educationalProgram.filteredOwnedPrograms.totalCount,
      customFilteredPrograms: state => state.educationalProgram.customFilteredPrograms,
      customOwnedFilteredPrograms: state => state.educationalProgram.customFilteredOwnedPrograms.programs,
      customTotalCount: state => state.educationalProgram.customFilteredOwnedPrograms.totalCount,
      showFullPageLoader: state => state.behavior.fullPageLoader.show,
      navigationOptions: state => state.educationalProgram.navigationOptions,
      showViewCatalogueModal: state => state.behavior.viewCatalogueModal.show,
      locale: state => state.behavior.locale
    }),
    ...mapGetters([
      'getProgramsListForCard',
      'getCustomProgramsListForCard'
    ]),
    hasFilters() {
      return Boolean(Object.keys(this.$route.query).length)
    },
    filteredPrograms() {
      return this.isCustom
        ? this.customFilteredPrograms
        : this.defaultFilteredPrograms
    },
    ownedFilteredPrograms() {
      return this.isCustom
        ? this.customOwnedFilteredPrograms
        : this.defaultOwnedFilteredPrograms
    },
    totalCount() {
      return this.isCustom
        ? this.customTotalCount
        : this.defaultTotalCount
    }
  },
  methods: {
    ...mapActions([
      'hydrateCategories',
      'hydrateAges',
      'hydrateFilteredPrograms',
      'hydrateCustomFilteredPrograms',
      'clearFilteredPrograms',
      'clearCustomFilteredPrograms',
      'hydrateFilteredOwnedPrograms',
      'hydrateCustomFilteredOwnedPrograms',
      'hydrateCustomEducationalPrograms',
      'hideElement',
      'showElement',
      'hydrateProfile',
      'setNavigationOptions'
    ]),
    clearPrograms() {
      if (this.isCustom) this.clearCustomFilteredPrograms()
      else this.clearFilteredPrograms()
    },
    async getMoreFilteredOwnedPrograms(pageNumber, pageSize = this.defaultPageSize) {
      this.showElement({ element: 'fullPageLoader' })
      if (this.isCustom) await this.hydrateCustomFilteredOwnedPrograms({ pageNumber, pageSize, filters: this.filters })
      else await this.hydrateFilteredOwnedPrograms({ pageNumber, pageSize, filters: this.filters })
      this.hideElement({ element: 'fullPageLoader' })
    },
    async getMoreFilteredPrograms({ pageNumber }) {
      if (this.isCustom) {
        await this.hydrateCustomFilteredPrograms({ pageNumber,
          pageSize: 4,
          filters: {
            purchasedStatus: [educationalProgramStatus.notPurchased],
            languageStatus: [educationalProgramLanguageStatus.comingSoon]
          } })
      } else {
        await this.hydrateFilteredPrograms({ pageNumber,
          pageSize: 4,
          filters: {
            purchasedStatus: [educationalProgramStatus.notPurchased],
            languageStatus: [educationalProgramLanguageStatus.comingSoon]
          } })
      }
    },
    setSearchParams(filters) {
      this.filters = filters
      this.$refs.paginatedTable.goToPage(firstPage, filters)
    },
    clearFilters() {
      this.filters = {}
      this.defaultPageSize = defaultProgramsPageSize
    },
    async changeDefaultPageSize(newPageSize) {
      this.defaultPageSize = newPageSize
      await this.$refs.paginatedTable.changePageSize(null, newPageSize)
    },
    handleCatalogue() {
      this.showElement({ element: 'viewCatalogueModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/sizes';
@import '../scss/variables/colors';

.carousel-container {
  margin-top: 50px;
}

.suggest {
  padding: 0 10px;
}

.catalog {
  margin: 0 10px;
}

.secondary-button {
  --max-width: 210px;
}

.searchbar-container {
  background-color: $lighter-gray;
}

.view-container {
  display: flex;
  flex-direction: column;
  max-width: $content-size;
  width: 100%;
  margin: 30px auto 0;
  padding-bottom: 60px;
}

.card {
  margin-left: 10px;
  margin-right: 10px;
  max-width: 310px;
  width: 100%;
}

.program-card-grid{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.program-card-list{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
</style>
